export const ClientMode = {
  CAPTURE: "capture",
  FULL: "full",
  EXCHANGE: "exchange",
  NETWORK_REPORTS_ONLY: "networkReportsOnly",
};

export const SHOW_ADDITIONAL_PROVIDERS_AND_ORDER_ID =
  "exchange_additional_providers_and_order_id";
export const PROVIDERS_MGMT_TAB = "exchange_provider_management";
export const RECIPIENT_PROXIMITY = "exchange_select_recipient_proximity";
export const ADP_AUTOPOPULATE_PATIENT = "exchange_adp_auto_populate_patient";
export const CAPTURE_PATIENTS_TAB = "exchange_patients_tab_in_capture";
export const SHOW_ERROR_TOASTS = "exchange_show_error_toasts";
export const ADP_SPLIT_IN_CAPTURE = "exchange_adp_split_in_capture";
